module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/soapBars@2x_5890f4.png";